import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LegalPolicyContent from '../components/LegalPolicyContent';
import '../styles/PolicyPage.css';

export default function PolicyPage({ user }) {
  return (
    <div className="page-shell">
      <Header user={user} showMenu={false} />
      <main className="page-main">
        <section className="policy-page">
          <h1>プライバシーポリシー / Privacy Policy</h1>
          <p className="policy-lead">
            本サービスのプライバシーポリシーです。 / This is the privacy policy for this service.
          </p>
          <LegalPolicyContent mode="privacy" />
        </section>
      </main>
      <Footer />
    </div>
  );
}
